const About = () => {
    return (
        <section id="about" class="about">
            <div class="container">
                <div class="entry" style={{paddingRight: "0", paddingBottom: "20vmin"}}>
                    <p class="entry-text" style={{textAlign: "right"}}>Nuestra <strong>experiencia</strong> nos llevó a liderar emprendimientos residenciales,<br id="d-only" /> comerciales e industriales de distinta magnitud, siempre con el foco puesto <br id="d-only" />en la excelencia y la máxima calidad.</p>
                </div>
            </div>
        </section>
    )
}

export default About